
/**
 * Created by Mateusz Lipowski on 08.11.2016.
 */

namespace Action.MainMenu {
    export class MenuEditCategory extends Action.UserActionBase {
        protected window: Entity.View.Window.Window = null;
        protected table: HTMLTableElement = null;

        protected onCategoryUpdateCallbackId: number;
        protected proxyListenerEditCategoryButtonClick: (e: MouseEvent) => void;
        protected proxyListenerAddCategoryButtonClick: (e: MouseEvent) => void;

        public constructor(event: Action.UserActionEvent) {
            super(event);

            this.proxyListenerEditCategoryButtonClick = (e: MouseEvent): void => {
                this.onEditCategoryButtonClick(e.target as HTMLInputElement);
            };
            this.proxyListenerAddCategoryButtonClick = (e: MouseEvent): void => {
                this.onAddCategoryButtonClick(e.target as HTMLInputElement);
            };
        }

        public execute(): void {
            let menuItem = this.event.target;
            this.initView();
            this.populateCategories();

            this.onCategoryUpdateCallbackId = this.app.service.callbackContainer.pushCallback('category', 'update', (e: Control.CallbackContainer.Event): boolean => {
                this.populateCategories();
                return true;
            });
        }

        protected onEditCategoryButtonClick(button: HTMLInputElement): void {
            let categoryId: number = parseInt(button.dataset['category_id']);
            let category: Entity.Map.Type.Category = this.app.entityContainer.findCategory(categoryId);

            if(!category) {
                let alert: Entity.View.Alert = new Entity.View.Alert(Entity.View.AlertType.ERROR, 'Wybrana kategoria nie istnieje');
                alert.show();
                return;
            }

            Factory.UserActionFactory.invokeAction('CategoryEdit', 'Other', new Action.UserActionEvent(category, {}));
        }

        protected onAddCategoryButtonClick(button: HTMLInputElement): void {
            Factory.UserActionFactory.invokeAction('CategoryAdd', 'Other', new Action.UserActionEvent(this, {}));
        }

        protected initView(): void {
            this.window = this.app.service.windowContainer.createWindow(Control.WindowClass.WINDOW);
            this.window.show('categories');
            this.window.setWide();
            this.window.setOnDismiss((): void => {
                this.dispose();
            });

            this.table = this.window.getForm().getElementsByClassName('categories-table')[0] as HTMLTableElement;
            if(!this.table)
                throw new Error('Brak tabeli kategorii w oknie kategorii');

            let newOfferButton: HTMLInputElement = this.window.getForm().getElementsByClassName('new-category')[0] as HTMLInputElement;
            newOfferButton.addEventListener('click', this.proxyListenerAddCategoryButtonClick);
        }

        protected dispose(): void {
            this.app.service.callbackContainer.deleteCallbackById('category', 'update', this.onCategoryUpdateCallbackId);
        }

        protected populateCategories(): void {
            if(!this.table) {
                throw new Error('UserAction.MainMenu.MenuType.populateTypes: Table element is undefined');
            }

            this.removeAllChildren(this.table);
            this.createTableHeader();

            for(let category of this.app.entityContainer.categories) {
                if(!category)
                    continue;

                this.appendTypeRow(category);
            }
        }

        protected appendTypeRow(category: Entity.Map.Type.Category): void {
            let id = this.createSpan(category.id.toString(), null, 'offer-element id');
            let name = this.createSpan(category.name, null, 'offer-element name');
            let color = this.createColor('#' + category.color, null, 'offer-element color');
            let priority = this.createSpan(category.priority.toString(), null, 'offer-element priority');
            let button = document.createElement('input') as HTMLInputElement;

            button.type = 'button';
            button.value = 'Edytuj';
            button.setAttribute('data-category_id', category.id.toString());
            button.addEventListener('click', this.proxyListenerEditCategoryButtonClick);

            let row: HTMLTableRowElement = null;
            row = this.createTableRow('td', id, name, color, priority, button);

            this.table.appendChild(row);
        }

        protected createTableHeader(): void {
            let row: HTMLTableRowElement = this.createTableRow('th', 'ID', 'Nazwa', 'Kolor', 'Priorytet koloru', '');
            this.table.appendChild(row);
        }
    }
}
